import React from 'react'
import Common from '../../utils/common';
import Configuration from '../../config';
import Pagination from "react-js-pagination";
import { Redirect, Route, Switch } from "react-router";

export default class List extends React.Component {
    
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            activePage: 1
        }
        if (this.props.match.params.name != undefined) {
            window.location.href = "/" + this.props.match.params.language + "/danh-sach-bai-viet/" + this.props.match.params.name;
        }


    }
    componentDidMount() {        
        this.setState({ activePage: 1 });
    }
    handlePageChange(pageNumber) {
        Common.activePage = pageNumber;
        this.setState({ activePage: pageNumber });

    }
    render() {
        var page = this.props.match.params.page;
        var hash = window.location.hash;
        
        if(hash != "" && page == undefined)
        {
            console.log(hash);
            page = parseInt(hash.substring(1));
        }

        if(page == undefined || page == NaN)
        {
            page = 1;
        }
        
        console.log(page);
        var paramId = this.props.match.params.id;
        var param = {};
        param['paramId'] = paramId;
        param['friendlyUrl'] = this.props.match.params.friendlyUrl;
        
        if (page != undefined) {
            window.Merchant.page = page;
            Common.activePage = page;
        }
        this.state.build = Common.getPage('articles', param, page);
        return (
            <main>
                <div dangerouslySetInnerHTML={{ __html: this.state.build }}>
                </div>
            </main>
            // <div>
            //     <div dangerouslySetInnerHTML={{ __html: this.state.build }}>
            //     </div>
            //     <div className="container">
            //         <div className="row">
            //             <div className="col-12 mt-2 mt-md-4 mb-2 mb-md-4">
            //                 <Pagination
            //                     activePage={this.state.activePage}
            //                     itemsCountPerPage={Configuration.pageSizeArticles}
            //                     totalItemsCount={Common.totalItemsCount}
            //                     pageRangeDisplayed={5}
            //                     onChange={this.handlePageChange.bind(this)}
            //                     innerClass="pagination pagination izzi-justify-content"
            //                     activeLinkClass="active"
            //                 />
            //             </div>
            //         </div>
            //     </div>


            // </div >

        )

    }

}

